// League Uniform Management App Index
// Routes to the appropriate League Uniform Management page based on the URL

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import Dashboard from './Dashboard';
import OrderCreation from './OrderCreation';

const UniformOrdersApp = () => {
  return (
    <Routes>
      {/* Main dashboard */}
      <Route
        path="/"
        element={
          <ProtectedRoute requiredPermission="uniform-orders:read">
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* Order creation page */}
      <Route
        path="/order-creation"
        element={
          <ProtectedRoute requiredPermission="uniform-orders:write">
            <OrderCreation />
          </ProtectedRoute>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/league-uniform-management" replace />} />
    </Routes>
  );
};

export default UniformOrdersApp;
